import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

const exportGraphAsImage = (canvasRef) => {
    const canvas = canvasRef.current
    if (!canvas) return

    const tempCanvas = document.createElement('canvas')
    tempCanvas.width = canvas.width
    tempCanvas.height = canvas.height
    const ctx = tempCanvas.getContext('2d')

    ctx.fillStyle = 'white'
    ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height)
    ctx.drawImage(canvas, 0, 0)

    try {
      const link = document.createElement('a')
      link.href = tempCanvas.toDataURL('image/png', 1.0)
      link.download = `graphe-Dantzig-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.png`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error("Export error:", error)
      toast.error("Erreur lors de l'export", {
        position: 'top-right',
        autoClose: 2000,
        closeButton: false,
        hideProgressBar: true,
        transitionDuration: 0,
        theme: 'colored',
        icon: <HighlightOffIcon style={{ color: 'white' }} />
      })
    }
}

const generateExample = (
    canvasRef, setNodes, setEdges, setStartNode, setEndNode, resetEdgeSelection,
    setPath, setShowSteps, setSteps
) => {
    // On lit la taille RÉELLEMENT affichée du canvas (CSS), pas l'attribut interne,
    // pour être sûr que les sommets sont placés dans la zone visible sur mobile.
    const rect = canvasRef.current.getBoundingClientRect()
    const canvasWidth = rect.width
    const canvasHeight = rect.height

    const exampleNodes = [
      { id: 1, name: 'x₁', x: canvasWidth * 0.1, y: canvasHeight * 0.5 },
      { id: 2, name: 'x₂', x: canvasWidth * 0.2, y: canvasHeight * 0.5 },
      { id: 3, name: 'x₃', x: canvasWidth * 0.3, y: canvasHeight * 0.7 },
      { id: 4, name: 'x₄', x: canvasWidth * 0.3, y: canvasHeight * 0.3 },
      { id: 5, name: 'x₅', x: canvasWidth * 0.4, y: canvasHeight * 0.2 },
      { id: 6, name: 'x₆', x: canvasWidth * 0.4, y: canvasHeight * 0.6 },
      { id: 7, name: 'x₇', x: canvasWidth * 0.5, y: canvasHeight * 0.5 },
      { id: 8, name: 'x₈', x: canvasWidth * 0.5, y: canvasHeight * 0.3 },
      { id: 9, name: 'x₉', x: canvasWidth * 0.5, y: canvasHeight * 0.1 },
      { id: 10, name: 'x₁₀', x: canvasWidth * 0.6, y: canvasHeight * 0.2 },
      { id: 11, name: 'x₁₁', x: canvasWidth * 0.6, y: canvasHeight * 0.6 },
      { id: 12, name: 'x₁₂', x: canvasWidth * 0.7, y: canvasHeight * 0.3 },
      { id: 13, name: 'x₁₃', x: canvasWidth * 0.7, y: canvasHeight * 0.6 },
      { id: 14, name: 'x₁₄', x: canvasWidth * 0.8, y: canvasHeight * 0.5 },
      { id: 15, name: 'x₁₅', x: canvasWidth * 0.8, y: canvasHeight * 0.3 },
      { id: 16, name: 'x₁₆', x: canvasWidth * 0.9, y: canvasHeight * 0.4 },
    ]

    const exampleEdges = [
      { id: '1-2', source: 1, target: 2, weight: 10 },
      { id: '2-3', source: 2, target: 3, weight: 15 },
      { id: '2-4', source: 2, target: 4, weight: 8 },
      { id: '3-6', source: 3, target: 6, weight: 1 },
      { id: '3-11', source: 3, target: 11, weight: 16 },
      { id: '4-5', source: 4, target: 5, weight: 6 },
      { id: '4-3', source: 4, target: 3, weight: 8 },
      { id: '5-9', source: 5, target: 9, weight: 1 },
      { id: '6-5', source: 6, target: 5, weight: 5 },
      { id: '6-7', source: 6, target: 7, weight: 4 },
      { id: '7-8', source: 7, target: 8, weight: 1 },
      { id: '7-11', source: 7, target: 11, weight: 8 },
      { id: '8-7', source: 8, target: 7, weight: 1 },
      { id: '8-10', source: 8, target: 10, weight: 2 },
      { id: '9-8', source: 9, target: 8, weight: 3 },
      { id: '9-10', source: 9, target: 10, weight: 6 },
      { id: '10-12', source: 10, target: 12, weight: 7 },
      { id: '11-12', source: 11, target: 12, weight: 6 },
      { id: '11-13', source: 11, target: 13, weight: 2 },
      { id: '12-15', source: 12, target: 15, weight: 9 },
      { id: '13-14', source: 13, target: 14, weight: 4 },
      { id: '14-16', source: 14, target: 16, weight: 3 },
      { id: '15-14', source: 15, target: 14, weight: 5 },
      { id: '15-16', source: 15, target: 16, weight: 6 },
    ]

    setNodes(exampleNodes)
    setEdges(exampleEdges)
    setStartNode(exampleNodes[0])
    setEndNode(exampleNodes[15])
    resetEdgeSelection()
    setPath([])
    setShowSteps(false)
    setSteps([])
}

export const graphUtils = {
    exportGraphAsImage, generateExample
}